(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lf-editorial"] && !Shopify.designMode) return;
  try {
    
function initLFSlides(root){
 root.querySelectorAll('.lf-hero').forEach(hero=>{
 if(hero.dataset.slidesReady)return;
 hero.dataset.slidesReady='true';
 const slides=[...hero.querySelectorAll('.lf-hero__slide')],button=hero.querySelector('.lf-hero__playback');
 if(slides.length<2){if(button)button.hidden=true;return;}
 const reduced=matchMedia('(prefers-reduced-motion:reduce)');
 let current=0,timer,manual=reduced.matches,visible=true;
 const stop=()=>{clearTimeout(timer);hero.classList.add('is-paused');button.textContent=button.dataset.play;};
 const schedule=()=>{clearTimeout(timer);if(manual||!visible||document.hidden){stop();return;}hero.classList.remove('is-paused');button.textContent=button.dataset.pause;timer=setTimeout(next,4000);};
 async function next(){
 if(!hero.isConnected)return;
 const index=(current+1)%slides.length,incoming=slides[index],outgoing=slides[current],img=incoming.querySelector('img');
 img.loading='eager';
 try{await img.decode();}catch{schedule();return;}
 if(manual||!visible||document.hidden)return;
 incoming.classList.add('is-active','is-moving');outgoing.classList.remove('is-active');
 setTimeout(()=>outgoing.classList.remove('is-moving'),1600);
 current=index;schedule();
 }
 button.addEventListener('click',()=>{manual=!manual;manual?stop():schedule();});
 document.addEventListener('visibilitychange',()=>{if(hero.isConnected)schedule();});
 if('IntersectionObserver' in window)new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule();},{threshold:.05}).observe(hero);
 reduced.addEventListener('change',()=>{manual=reduced.matches;schedule();});
 schedule();
 });
}
initLFSlides(document);document.addEventListener('shopify:section:load',event=>initLFSlides(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-history"] && !Shopify.designMode) return;
  try {
    
function initLFHistory(root){if(matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver' in window)||window.Shopify?.designMode)return;const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.remove('is-waiting');observer.unobserve(entry.target)}})},{threshold:.08});root.querySelectorAll('.lf-history__chapter').forEach(el=>{if(el.getBoundingClientRect().top>innerHeight){el.classList.add('is-waiting');observer.observe(el)}})}
initLFHistory(document);document.addEventListener('shopify:section:load',event=>initLFHistory(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
